/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { Directive } from '@angular/core';
import { AbstractControl, ValidationErrors, Validator } from '@angular/forms';
import { BaseComponent } from 'src/shared/abstracts/base.abstract';

@Directive()
export abstract class FormValidatorComponent extends BaseComponent implements Validator {
    public validatorOnChange = (): any => {};

    public validate(control: AbstractControl): ValidationErrors | null {
        return null;
    }

    public registerOnValidatorChange?(fn: () => void): void {
        this.validatorOnChange = fn;
    }
}
